export class CoverageClaim {
    coverageId: number;
    claimId: number;
}


// WEBPACK FOOTER //
// ./src/app/modules/validate-loss-data-submission/shared/entities/coverageClaim.ts